import {breakpoints, Devices, tokens} from './tokens';

// colCount = the amount of cols you want
// containerCols = the amount of cols the container takes up
// innerPads = how many column paddings you want
// outerPads = how many paddings the container has
// outerMargin = used for --site-width, any margin the container may have

// This is just bc I need this thing to work asap, so I basically copied the SCSS function

export function col(colCount: number, containerCols: number = tokens.desktopCols): string {
  return `calc(((var(--site-width) + var(--gutter)) / ${containerCols}) * ${colCount} - var(--gutter))`;
}

// function breakpoint(colCount: number, containerCols: number = tokens.desktopCols, innerPads: number = 0, outerPads: number = 0, outerMargin: number = 0): string {
//   return `calc(((var(--site-width) + var(--gutter)) / ${containerCols}) * ${colCount} - var(--gutter))`;
// };

export function mobileCol(colCount: number, containerCols = tokens.mobileCols, innerPads = 0, outerPads = 0, outerMargin = 0): string {
  return `calc(((((100% - ${outerMargin}px) - ${tokens.mobilePadding} * (${outerPads} - 1)) / ${containerCols}) * ${colCount}) + ${tokens.mobilePadding} *(${outerPads} - 1) + ${tokens.mobilePadding} * ${innerPads})`;
}

export function aspectRatioFix(width: number, height: number) {
  const percent = (height / width) * 100;
  return `padding-top: ${percent}%;
    position: relative !important;
    height: 0;`;
}

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
};

function dynamicFontSize(siteWidth: number, referenceWidth: number, fontSize: number): string {
  return `calc(${fontSize}px + ((${siteWidth} - ${referenceWidth}px) * 0.0005 * ${fontSize}))`;
}

export const mq = (device: Devices) => {
  const breakPointArray = Object.keys(breakpoints).map((key) => [key, breakpoints[key]]);
  const [result] = breakPointArray.reduce((acc, [name, size]) => {
    if (device === name) return [...acc, `@media all and (max-width: ${size}px)`];
    return acc;
  }, []);

  return result;
};
